import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/common/Logo";
import { hasPermission } from "@/lib/constants";

export default function ProtectedRoute({ children, roles, permission }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-background subtle-grid">
        <div className="flex flex-col items-center gap-4">
          <Logo size={44} />
          <div className="text-xs uppercase tracking-widest text-muted-foreground animate-pulse">
            Loading…
          </div>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (
    (roles && !roles.includes(user.role)) ||
    (permission && !hasPermission(user, permission))
  ) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
